import React from 'react'
import Modal from 'components/modal'
import { parseTimeZone } from 'assets/localization'
import Button from 'components/controls/button'

import 'less/unable-to-remove-moderator-modal.less'

const UnableToRemoveModeratorModal = props => {

    const count = props.flag && props.flag === "single" ? 1 : 2

    const goBack = () => {
        props.onCancel()
        props.toggleAddModeratorsModal({ moderatorsScheduledInterviews: props.moderatorsScheduledInterviews, 
            modifiedModerators: props.modifiedModerators, 
            defaultModerators: props.defaultModerators, 
            status: props.status, 
            defaultModeratorsDetails:props.defaultModeratorsDetails,
            modifiedModeratorsIds: props.modifiedModeratorsIds,
            clientId: props.clientId,
            messageKey: props.messageKey
         })
    }

    const manageModeratorRedirection = (moderatorId, clientId, firstName, lastName) => {
        props.setSingleModerator(({id: moderatorId, clientId: clientId, label: `${firstName} ${lastName}`}))
        props.history.push(`/moderatorManagement/schedule`)
    }

    return (
        <Modal
            title={props.showUnableToRemoveModErrorMessage ? props.t('future.availability.required.title') : props.t('unable.to.remove.moderator.title(s)', { count: count })}
            isOpen={props.isOpen}
            className="unable-to-remove-moderator-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText="Ok"
            showCancelBtn={props.showCancelBtn}
            onCancel={props.onCancel}
            onSubmit={(props.flag === 'single') ? props.onCancel : goBack}
            showXBtn={(props.flag === 'single') ? true : false}
        >
            {props.showUnableToRemoveModErrorMessage ?
                <div>
                    <p> {props.t('future.availability.required.message.part1')}</p>
                    <p> {props.t('future.availability.required.message.part2')}</p>
                </div>
                :
                <div>
                    <p> {props.t('scheduled.interviews.error.message.part1')} {count === 1 ? '' : props.t('scheduled.interviews.error.message.part5')} </p>   
                    <p> {props.t('scheduled.interviews.error.message.part2')} </p>     
                    <p className='manage-moderator-page' dangerouslySetInnerHTML={{
                                    __html: props.t('scheduled.interviews.error.message.part3', {
                                        markup: { tagStart: `<a href='${window.location.origin}/moderatorManagement/schedule'> Manage Moderator Page </a>` }
                                    })
                                }} /> 
                    <p> {props.t('scheduled.interviews.error.message.part4')} </p>
                    <div className={`interviews-container`}>
                        {props.moderatorsScheduledInterviews && props.isOpen &&
                            Object.entries(props.moderatorsScheduledInterviews).map(item =>
                                <div key={item[0]} >
                                    <div>
                                        <div className="moderator-name">{item[1][0].firstName} {item[1][0].lastName}
                                            <span className='moderator-id'> Moderator #{item[0]}  </span>
                                            <Button className='manage-moderator-page btn-primary'
                                                onClick={() => manageModeratorRedirection(item[0], props.clientId, item[1][0].firstName, item[1][0].lastName)}
                                            > Manage
                                             <i className="im-edit" />
                                            </Button>
                                        </div>
                                    </div>
                                    {item[1].map(interview =>
                                        <div className="interviews-info">
                                            <div className="moderator-container">
                                                <div className='interview-name'> {interview.projectName} #{interview.salesforce}</div>
                                                <div>{props.formatDate(interview.startTime, 'MMM DD, YYYY')} from {props.formatDate(interview.startTime, 'h:mm a')} - {props.formatDate(interview.endTime, 'h:mm a')} {parseTimeZone(props.userTimeZone)}</div>
                                                <div> Participant ID: #{interview.participantId}</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                    </div>
                </div>
            }
        </Modal>
    )
}

export default UnableToRemoveModeratorModal
